import appConfig from "../../../../config/appConfig";
import { POA_TENANTS } from "../../../../utils/constants";

/** KYC forms listing/details: enabled by env flag and limited to POA tenants. */
export const isKycFormsPagesAccessible = (activeTenant?: string | null) => {
  return appConfig.app.is_kyc_forms_pages_enabled && POA_TENANTS.includes(activeTenant ?? "");
};
